module.exports = __webpack_public_path__ + "assets/b4df17cef6d0d40a08daee291de13275.svg";